module.exports = __webpack_public_path__ + "media/images/placeholders/kaufsucht-61a0e9be67289a67be1b8f5f4b4f1c48.jpg";